import React, { useContext, useEffect } from 'react'
import { AppSettings } from '../../config/app-settings'
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader
} from '../../components/other/card/card'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Select } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { useChangeStatusMutation } from '../../redux/apis/linkManagement/changeGetLink/lMChangeGetLinkApiSlice'
import Loader from '../pages/loader'
import { toast } from 'react-toastify'
import generateExcel from '../../helpers/generateExcel'
import { dateNow } from '../../helpers/date'

const ChangeLinksStatus = React.memo(() => {
  const context = useContext(AppSettings)
  const [create, { isLoading, error }] = useChangeStatusMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      urls: '',
      status: ''
    },
    validationSchema: Yup.object({
      urls: Yup.string().required('please Enter Urls'),
      status: Yup.string().required('please Enter Report Status')
    }),

    onSubmit: async values => {
      const urls = values.urls
        .split('\n')
        .map(url => url.trim())
        .filter(url => url)
      const data = {
        urls: urls,
        is_related: values.status
      }

      try {
        const res = await create(data)
        toast.info(`${res?.data?.data?.updated_links?.length} Links submitted`)
        
        if (!res?.data?.success) {
          toast.error(
            `${res?.data?.data?.failed_links} Links failed, Please Check report.`
          )
          function convertToExcelRows (errors) {
            const rows = []
            // Iterate over each key-value pair in the input data
            for (const [url, details] of Object.entries(errors)) {
              // Create a row object for each entry
              const row = {
                URL: url,
                status: details?.success,
                error: details?.errors?.map(x => x.message).join(', ')
              }
              // Push the row into the rows array
              rows.push(row)
            }
            return rows
          }
          if (res?.data?.errors) {
            generateExcel(
              convertToExcelRows(res?.data?.errors),
              `URL updatting errors ${dateNow()}`
            )
          }
        } else {
          toast.success('Links updated Successfully.')
        }
      } catch (error) {
        console.error(error)
      }
    }
  })

  
    useEffect(() => {
      if (error?.data) {
        const errorMessages = Object.values(error.data).flat()
        errorMessages.forEach(message => {
          toast.error(message)
        })
      }
    }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context]) // Add context as a dependency

  return (
    <div>
      <Loader isLoading={isLoading} />
      <Card>
        <CardHeader>
          <p>Change Links Status</p>
        </CardHeader>
        <CardBody>
          <div className='mb-3'>
            <label className="form-label">Report Status</label>
            <br />
            <Select
              name='status'
              className={'customSelect'}
              style={{
                width: '100%'
              }}
              onBlur={validation.handleBlur}
              onChange={e => {
                validation.setFieldValue('status', e)
              }}
              value={validation.values?.status}
              options={[
                { label: 'Related', value: true },
                { label: 'UnRelated', value: false }
              ]}
            />
          </div>
          {validation.touched.status && validation.errors.status ? (
            <p className='text-danger'>{validation.errors.status}</p>
          ) : null}
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">URLs (separated by new lines)</label>
            <TextArea
              type='text'
              name='urls'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.urls}
              placeholder='Enter urls separated by new lines
              example:
              test.com
              test2.com
              test3.com
              '
              rows={15}
            />
            {validation.touched.urls && validation.errors.urls ? (
              <p className='text-danger'>{validation.errors.urls}</p>
            ) : null}
          </div>
        </CardBody>
        <CardFooter>
          <div className='flex justify-end gap-8'>
            <button
              onClick={() => {
                validation.handleSubmit()
              }}
              className='btn btn-theme'
            >
              Submit
            </button>
          </div>
        </CardFooter>
      </Card>
    </div>
  )
})

export default ChangeLinksStatus
